import axios from "axios";
import { DOCUMENT_TYPE_URL } from "./api";
import { authorizationHelper } from "../common/helpers";

export function getAll() {
    return axios.get(DOCUMENT_TYPE_URL, {
        headers: { Authorization: authorizationHelper.getAuthorizationToken() }
    });
}



// WEBPACK FOOTER //
// ./src/service/documentType.js